import { createContext, useContext, useState } from "react";

const PeriodContext = createContext({ period: 30, setPeriod: () => {} });

export function PeriodProvider({ children }) {
  const [period, setPeriod] = useState(30);
  return (
    <PeriodContext.Provider value={{ period, setPeriod }}>
      {children}
    </PeriodContext.Provider>
  );
}

export const usePeriod = () => useContext(PeriodContext);
